<template>
    <h1>logout page</h1>
</template>

<script>
export default {
    mounted() {
        const query = this.$route.query.relog
        this.$store.dispatch('logout').then(result => {
            if (query) {
                this.$store.dispatch('startLogin')
            } else {
                console.log(process.env.FRONTPAGE_URL)
                location.href = process.env.FRONTPAGE_URL
            }
        })
    },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/logout.vue